import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useJsApiLoader } from '@react-google-maps/api';
import { useBreakpointDown } from '@travel-frontend/core';
import { GoogleMap } from '../../../../components/HotelDetailsOverlay/components/MapSection/components/GoogleMap.js';
import { MapContainer } from '../../../../components/HotelDetailsOverlay/components/MapSection/components/MapContainer.js';
import { useConfig } from '../../../../components/HotelDetailsOverlay/context/Config.js';
export const MapSection = ({
  data: {
    latitude,
    longitude,
    hotelName
  }
}) => {
  const lgDown = useBreakpointDown('lg');
  const {
    map: mapConfig
  } = useConfig();
  const {
    isLoaded
  } = useJsApiLoader(mapConfig.googleMapsApiOptions);
  const mapOptions = {
    mapId: mapConfig.googleMapsStyleId,
    zoom: 15,
    disableDefaultUI: true,
    mapTypeControl: true,
    mapTypeControlOptions: {
      mapTypeIds: ['roadmap', 'satellite']
    },
    minZoom: 7,
    gestureHandling: 'greedy',
    clickableIcons: true
  };
  const mapOptionsDesktop = {
    mapId: mapConfig.googleMapsStyleId,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeControl: true,
    mapTypeControlOptions: {
      mapTypeIds: ['roadmap', 'satellite']
    },
    zoomControl: true,
    zoomControlOptions: {
      position: 7
    },
    minZoom: 7,
    clickableIcons: true
  };
  return _jsx(MapContainer, {
    children: isLoaded && _jsx(GoogleMap, {
      lat: latitude,
      lng: longitude,
      hotelName: hotelName,
      mapOptions: lgDown ? mapOptions : mapOptionsDesktop
    })
  });
};